import React from "react";
import { selectFormat } from "../Utils.js";
import { XRayTooltipHeader } from "./../XrayUtils.js";

export const XRayEmail = (props) => {
  const { data, close } = props;

  return (
    <div>
      <XRayTooltipHeader
        date={data.activePayload[0].payload.name.split("-")[0]}
        close={close}
      />
      <main className="standard-tooltip__main">
        <div className="standard-tooltip__item">
          <span className="standard-tooltip__key">Email:</span>
          <span className="standard-tooltip__value">
            {data.activePayload[0].payload.name.split("-")[1]}
          </span>
        </div>
        {Object.keys(data.activePayload)
          .sort(
            (a, b) => data.activePayload[b].value - data.activePayload[a].value
          )
          .filter((key) => data.activePayload[key].value > 0)
          .map((key, index) => {
            return (
              <div className="standard-tooltip__item" key={key}>
                <span
                  className="standard-tooltip__icon"
                  // set the backgroun color according the chart name
                  style={{
                    background: data.activePayload[key].color,
                  }}
                />

                {data.activePayload[key].name === "click_rate"
                  ? "Click Rate"
                  : "Open Rate"}

                <span className="standard-tooltip__value">
                  {selectFormat("percentage", data.activePayload[key].value)}
                </span>
              </div>
            );
          })}
      </main>
    </div>
  );
};
